// extracted by mini-css-extract-plugin
export default {"actions":"CampaignSubmissionReviewActionsBanner_actions__LTa44","container":"CampaignSubmissionReviewActionsBanner_container__yy8rx"};